import React from "react";
import { Container, Typography, Grid, Card, CardContent, Box } from "@mui/material";

const projects = [
  { title: "COMET • Neurealm", desc: "Spring Boot + React modules, REST APIs, AWS deployment" },
  { title: "SMART • Neurealm", desc: "Responsive React frontend, Spring Boot backend, authentication module" },
  { title: "Runapps AI Automation", desc: "Workflow automation using n8n, modular design for scalability" },
  { title: "HRMS • Arshaa Technologies", desc: "Employee management, role-based access, reporting dashboards" },
  { title: "PROPERTIES • Arshaa Technologies", desc: "Property listing & booking (Java + React), AWS deployment" },
];

function Projects() {
  return (
    <Box id="projects" sx={{ py: 8 }}>
      <Container>
        <Typography variant="h4" gutterBottom>Projects</Typography>
        <Grid container spacing={3}>
          {projects.map((proj, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Card
                elevation={4}
                sx={{
                  transition: "transform 0.3s, box-shadow 0.3s",
                  "&:hover": { transform: "scale(1.03)", boxShadow: 8 },
                  bgcolor: "background.paper",
                }}
              >
                <CardContent>
                  <Typography
                    variant="h6"
                    sx={{ color: "#52B2BF", fontWeight: "bold", mb: 1 }}
                  >
                    {proj.title}
                  </Typography>
                  <Typography variant="body2">{proj.desc}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default Projects;
